module.exports = __webpack_public_path__ + "img/36-image-1-1@2x.f8f701b5.png";